import classnames from 'classnames/bind'
import { GlobalThemeColors } from '~/@types/colors'
import { GlobalGridPreset } from '~/@types/grid-preset'
import { GlobalTextPreset } from '~/@types/text-preset'
import { GlobalTextStyling } from '~/@types/text-styling'

import Image, { ImageProps } from '~/components/UI/Image'
import RichText, { RichTextBlock } from '~/components/UI/RichText'

import { useStyle } from '~/providers/StyleProvider'

import { isRTFilled } from '~/utils/check-empty-string'

import { EditoSliceProps } from '~/data/slices-data'

import css from './styles.module.scss'

const cx = classnames.bind(css)

const IMAGE_SIZES = [{ breakpoint: 'md', ratio: 1 / 2 }, { ratio: 1 }]

export type HeroHalfProps = EditoSliceProps & {
  className?: string
  isReversed?: boolean
  image?: ImageProps
  title: RichTextBlock
  subtitle: RichTextBlock
}

function HeroHalf({
  className,
  isReversed,
  image,
  title,
  subtitle,
  aboveTheFold,
}: HeroHalfProps) {
  const gridStyle = useStyle({ grid: GlobalGridPreset.BASE_GRID })
  const titleStyle = useStyle({
    textPreset: GlobalTextPreset.Title18_24SangBleu,
    color: GlobalThemeColors.Black,
  })
  const subtitleStyle = useStyle({
    textPreset: GlobalTextPreset.Text12GroteskMedium,
    textStyling: GlobalTextStyling.UpperCase,
    color: GlobalThemeColors.Black,
  })

  const hasContent = isRTFilled(title) || isRTFilled(subtitle)
  return (
    <div className={cx(css.HeroHalf, className, gridStyle, { isReversed })}>
      {image && (
        <Image
          className={cx(css.image)}
          layout="fill"
          objectFit="cover"
          asPlaceholder
          sizesFromBreakpoints={IMAGE_SIZES}
          priority={aboveTheFold}
          {...image}
        />
      )}
      {hasContent && (
        <div className={cx(css.contentContainer)}>
          <div className={cx(css.content)}>
            <RichText className={cx(css.title, titleStyle)} render={title} />
            <RichText
              className={cx(css.subtitle, subtitleStyle)}
              render={subtitle}
            />
          </div>
        </div>
      )}
    </div>
  )
}

HeroHalf.defaultProps = {}

export default HeroHalf
